<app-header></app-header>

<!-- Info block in the white area below the wave -->
<div class="welcome-info-block">
	<h1 class="welcome-name">{{ fullName }}</h1>
	<p class="welcome-email">{{ email }}</p>
</div>

<div style="padding: 8px 0 20px;">
	@if (isNative) {
		<div class="profile-menu-item" (click)="navigate('dati-personali')">
			I miei dati personali
			<i class="bi bi-chevron-right"></i>
		</div>
		<div class="profile-menu-item" (click)="navigate('cambia-password')">
			Cambia password
			<i class="bi bi-chevron-right"></i>
		</div>
	}
	<div></div>

	<div class="profile-menu-item" (click)="confirmLogout()">
		Logout
		<i class="bi bi-chevron-right"></i>
	</div>
</div>
